module.exports = __webpack_public_path__ + "static/media/1.46131f3e.jpg";